import { render, staticRenderFns } from "./taskCard.vue?vue&type=template&id=80531044&scoped=true&"
import script from "./taskCard.vue?vue&type=script&lang=js&"
export * from "./taskCard.vue?vue&type=script&lang=js&"
import style0 from "./taskCard.vue?vue&type=style&index=0&id=80531044&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80531044",
  null
  
)

export default component.exports